import { toast, Bounce } from "react-toastify";

/**
 * Shows a specialized authentication error snackbar without stacktrace ID
 * Used for 401 errors and authentication-related issues
 * @param message - Optional custom authentication error message
 */
export function showAuthErrorSnackbar(message: string = "Authentication required. Please log in to continue.") {
  toast.error(
    ({ closeToast: _ }) => (
      <div>
        <div style={{ 
          display: "flex", 
          alignItems: "center", 
          gap: "8px",
          marginBottom: "4px"
        }}>
          <span style={{ fontSize: "1.2em" }}>🔒</span>
          <strong>Authentication Required</strong>
        </div>
        <div style={{ color: "#666" }}>{message}</div>
      </div>
    ),
    {
      position: "top-right",
      autoClose: 6000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
      transition: Bounce,
    }
  );
}
